import { css } from 'lit'

export default css`
    .dropdown-container.has-trigger {
        position: absolute;
    }
    .dropdown-container {
        outline: 1px solid var(--grey5);
        border-radius: 4px;
        max-width: 345px;
        max-height: 340px;
        width: fit-content;
        overflow-y: auto;
        background-color: var(--white, white);
        z-index: 100;
        position: relative;
    }

    .title {
        padding: 1.25rem 1rem 0.25rem 1rem;
        font-weight: var(--font-weight-medium);
        text-transform: uppercase;
        font-size: var(--x-small);
        color: var(--grey4);
    }
`
